import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IIpConfig, EmptyIpConfig } from "./EmptyIpConfig";
import { IModel } from "./IpConfig";
import { Search } from "../../shared/Search";
import { ILogin, IPermissionProps } from "../../models/Login";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IIpConfig>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Branch_Ips", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IIpConfig> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyIpConfig });
    };

    const openEdit = async (rowDatauser: IIpConfig) => {
        // props.setModal({ open: true, singleData: rowDatauser });
        const response = await Fetch("Branch_Ips", "PUT", rowDatauser, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Deleted Successfully.", life: 3000 });
            props.setReload(!props.reload);
        }
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Branches</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData: IIpConfig) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData}
                emptyMessage="No Branches found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="branchName" header="Branch Name" sortable />
                <Column field="branch_IP" header="Branch IP" />
                {_roles.includes(1) && <Column body={actionBodyTemplate} />}
            </DataTable>
        </>
    );
}
